<!-- Full-bleed white surface: this page is hosted in a plugin window that already provides the frame,
     so a card on a tinted background would read as a second window inside the first one. -->
<div class="min-h-screen flex items-center justify-center bg-white">
  <div class="w-full max-w-md p-10 animate-slideUp">
    <!-- Header with Logo -->
    <div class="text-center mb-6">
      <div class="flex justify-center mb-4 px-8">
        <img src="/Logo.png" alt="Logo" class="w-full h-auto object-contain">
      </div>
      <h1 class="text-3xl font-semibold text-gray-800 mb-2 m-0">Welcome Back</h1>
      <p class="text-base text-gray-500 m-0">Sign in to your account to continue</p>
    </div>

    <!-- Login Form -->
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="flex flex-col gap-4">
      <!-- Email Field -->
      <div class="flex flex-col gap-2">
        <label for="email" class="block text-sm font-medium text-gray-700">Email Address *</label>
        <input
          id="email"
          pInputText
          type="email"
          formControlName="email"
          placeholder="Enter your email"
          class="w-full"
          [class.ng-invalid]="getFieldError('email')"
          autocomplete="email"
          >
        @if (getFieldError('email')) {
          <div class="text-xs text-red-500 min-h-[16px]">{{ getFieldError('email') }}</div>
        }
      </div>

      <!-- Password Field -->
      <div class="flex flex-col gap-2">
        <label for="password" class="block text-sm font-medium text-gray-700">Password *</label>
        <input
          id="password"
          pInputText
          type="password"
          formControlName="password"
          placeholder="Enter your password"
          class="w-full"
          [class.ng-invalid]="getFieldError('password')"
          autocomplete="current-password">
        @if (getFieldError('password')) {
          <div class="text-xs text-red-500 min-h-[16px]">{{ getFieldError('password') }}</div>
        }
      </div>

      @if (errorMessage) {
        <div class="bg-red-50 text-red-600 p-3 rounded-lg text-sm border border-red-200">
          {{ errorMessage }}
        </div>
      }

      <!-- Submit Button -->
      <div class="mt-2">
        <!-- The pButton directive rather than <p-button>: it renders a real <button> that keeps the id,
             which is what the plugin's UI automation addresses the control by. -->
        <button
          pButton
          id="signIn"
          type="submit"
          label="Sign In"
          class="w-full"
          [disabled]="loginForm.invalid || isLoading()"
          [loading]="isLoading()">
        </button>
      </div>
    </form>

    <!-- Footer -->
    <div class="mt-8 text-center">
      <p class="text-xs text-gray-600 m-0">
        Anguleris Revit Plugin • v{{ pluginVersion() }}
      </p>
    </div>
  </div>
</div>
